import { BookEditor } from './BookEditor';
import type { BookRawJson } from '../../lib/bookSchema';
import { createBook } from '../../lib/panelApi';

type Props = {
  accessToken: string;
  onDone: () => void;
};

const initialTemplate: BookRawJson = {
  metadata: {
    title: 'How to Win Friends & Influence People',
    subtitle: 'The Strategy of Human Connection',
    authors: ['Dale Carnegie'],
    publication_date: '1936',
    'ISBN-13': 9780671027032,
    publishers: ['Simon & Schuster'],
    original_page_count: 291,
    category: ['Self-Help', 'Psychology', 'Business'],
    tags: ['Communication', 'Leadership', 'Networking', 'Influence'],
    narrator_gender: 'Male',
    short_tagline: 'Unlock the secret frequency of human cooperation and respect.',
    full_description:
      "An Unplayist transformative analysis of the world's most famous guide to social engineering. We explore the 'Ego-Sync' philosophy, moving beyond simple tactics to a deeper understanding of human dignity and persuasive psychology.",
  },
  legal: {
    disclaimer_text:
      'This content is an unofficial analysis and summary by Unplayist. It is not affiliated with, authorized, or endorsed by the original author or publisher. Unplayist creates transformative educational content. To support the author, please purchase the original book.',
    copyright_status: 'Transformative Analysis / Fair Use intended.',
  },
  faq: [
    {
      question: 'Is this about manipulating people?',
      answer: 'No. Our analysis emphasizes that these techniques only work when the appreciation and interest are genuine.',
    },
  ],
  action_plan: [
    {
      day: 1,
      task_title: 'The No-Criticism Challenge',
      description: 'Go 24 hours without criticizing, condemning, or complaining. Observe your internal dialogue.',
    },
  ],
  mind_map: {
    label: 'Human Influence',
    children: [{ label: 'Fundamental Techniques', children: [{ label: "Don't Criticize" }, { label: 'Give Appreciation' }] }],
  },
  glossary: [
    {
      term: 'Ego-Sync',
      definition: "The act of aligning one's requests with the other person's desire for importance.",
      context: 'Unplayist Critical Concept',
    },
  ],
  simulation: {
    scenario: 'A colleague makes a mistake on a project report.',
    challenge: 'How do you correct them without causing resentment?',
    solution:
      'Begin with honest praise for their effort, mention your own similar mistakes first, and then frame the correction as a suggestion for improvement.',
  },
  social_snaps: [
    { text: 'You can make more friends in two months by becoming interested in others than in two years of trying to get others interested in you.' },
    { text: 'Criticism is a homing pigeon; it always returns to its sender.' },
  ],
};

export function AddBookFlow({ accessToken, onDone }: Props) {
  return (
    <BookEditor
      accessToken={accessToken}
      title="Add Book"
      initialContent={initialTemplate}
      initialFields={{
        status: 'draft',
        is_free: false,
        audio_cover_filename: 'audio_cover.png',
        book_cover_filename: 'book_cover.png',
        audio_demo_filename: 'demo.mp3',
        audio_full_filename: 'full.mp3',
        audio_full_minutes: 60,
        pdf_filename: '',
      }}
      submitLabel="Create book"
      onCancel={onDone}
      onSubmitBook={async (payload) => {
        await createBook(accessToken, payload);
        onDone();
      }}
    />
  );
}

